import { isDevelopment } from "@biblioteksentralen/utils";
import { Box, BoxProps } from "@chakra-ui/react";
import React, { ErrorInfo, ReactNode } from "react";
import { AlertBS } from "./AlertBS";

interface Props {
  boundaryName?: string;
  children: ReactNode;
}

interface State {
  hasError: boolean;
  error?: Error;
  errorInfo?: ErrorInfo;
}

const StyledPre = (props: BoxProps) => (
  <Box as="pre" paddingTop="0.5rem" wordBreak="break-all" whiteSpace="pre-wrap" fontSize="0.8rem" {...props} />
);

export class ErrorBoundaryBS extends React.Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error: any) {
    return { hasError: true };
  }

  componentDidCatch(error: any, errorInfo: any) {
    this.setState({ hasError: true, error, errorInfo });
    console.error(error, { errorInfo, boundaryName: this.props.boundaryName });
  }

  render() {
    if (this.state.hasError) {
      const stackTrace = this.state.errorInfo?.componentStack;
      const errormsg = this.state.error?.message;
      const info = this.props.boundaryName;

      return (
        <div>
          <AlertBS status="error">
            <p>Beklager, det skjedde en teknisk feil.</p>
            {isDevelopment() && (stackTrace || errormsg) && (
              <div>
                <StyledPre>{errormsg || ""}</StyledPre>
                <StyledPre>{info || ""}</StyledPre>
                <StyledPre>{stackTrace || ""}</StyledPre>
              </div>
            )}
          </AlertBS>
        </div>
      );
    }

    return this.props.children;
  }
}
